import { Button } from "antd";

export default function Accepted() {
  return (
    <div
      className="status_card"
      style={{ border: "1px solid #B9ECDE99", backgroundColor: "#ECF8F2" }}
    >
      <div className="titleBar">
        <img src="/images/potential-deals/status/accepted.svg" alt="" />
        <Button htmlType="button" className="mint-btn btn-sm" type="primary">
          Send to production
        </Button>
      </div>
      <h5> Proposal accepted! </h5>
      <h6> The customer approved this proposal. </h6>
    </div>
  );
}
